import { createDCHook, createMutationHook, collapseDataFromCall, collapseParams } from '../client';
import {
  linkDevice,
  reLinkDevice,
  onboardDevice,
  onboardDeviceByIdentifier,
  offboardDevice,
  getDeviceState,
  chargesettings,
  chargesettingsOverride,
  startSchedule,
  stopSchedule,
  toggleSchedule,
  getSessions,
  getSessionsAggregate,
} from '../services/HemsService';

export const useHemsLinkDevice = createMutationHook(
  collapseDataFromCall(
    collapseParams(collapseParams(linkDevice, 'requestBody', 'data'), 'data', 'redirectUri', 'vehicleVendorModel'),
  ),
  {
    injectables: ['label', 'customerId', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['redirectUri', 'vehicleVendorModel'] },
    ],
  },
);

export const useHemsReLinkDevice = createMutationHook(
  collapseDataFromCall(collapseParams(collapseParams(reLinkDevice, 'requestBody', 'data'), 'data', 'redirectUri')),
  {
    injectables: ['label', 'customerId', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['redirectUri'] },
    ],
  },
);

export const useHemsOnboardDevice = createMutationHook(onboardDevice, {
  injectables: ['label', 'customerId', 'businessUnit'],
  flattenData: false,
});

export const useHemsOnboardDeviceByIdentifier = createMutationHook(onboardDeviceByIdentifier, {
  injectables: ['label', 'customerId', 'businessUnit'],
  flattenData: false,
});

export const useHemsOffboardDevice = createMutationHook(offboardDevice, {
  injectables: ['label', 'customerId', 'businessUnit'],
  flattenData: false,
});

export const useHemsGetDeviceState = createDCHook('getDeviceState', collapseDataFromCall(getDeviceState), {
  injectables: ['label', 'customerId', 'businessUnit'],
  flattenData: true,
});

export const useHemsChargesettings = createMutationHook(
  collapseDataFromCall(
    collapseParams(collapseParams(chargesettings, 'requestBody', 'data'), 'data', 'deviceId', 'dailyChargeSettings'),
  ),
  {
    injectables: ['label', 'customerId', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['deviceId', 'dailyChargeSettings'] },
    ],
  },
);

export const useHemsChargesettingsOverride = createMutationHook(
  collapseDataFromCall(
    collapseParams(
      collapseParams(chargesettingsOverride, 'requestBody', 'data'),
      'data',
      'deviceId',
      'departureTime',
      'chargeModeSettings',
    ),
  ),
  {
    injectables: ['label', 'customerId', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['deviceId', 'departureTime', 'chargeModeSettings'] },
    ],
  },
);

export const useHemsStartSchedule = createMutationHook(collapseDataFromCall(startSchedule), {
  injectables: ['label', 'customerId', 'businessUnit'],
  flattenData: true,
});

export const useHemsStopSchedule = createMutationHook(collapseDataFromCall(stopSchedule), {
  injectables: ['label', 'customerId', 'businessUnit'],
  flattenData: true,
});

export const useHemsToggleSchedule = createMutationHook(collapseDataFromCall(toggleSchedule), {
  injectables: ['label', 'customerId', 'businessUnit'],
  flattenData: true,
});

export const useHemsGetSessions = createMutationHook(
  collapseDataFromCall(collapseParams(collapseParams(getSessions, 'requestBody', 'data'), 'data', 'cursor', 'limit')),
  {
    injectables: ['label', 'customerId', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['cursor', 'limit'] },
    ],
  },
);

export const useHemsGetSessionsAggregate = createMutationHook(
  collapseDataFromCall(
    collapseParams(
      collapseParams(getSessionsAggregate, 'requestBody', 'data'),
      'data',
      'granularity',
      'fromDate',
      'toDate',
      'cursor',
      'limit',
    ),
  ),
  {
    injectables: ['label', 'customerId', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['granularity', 'fromDate', 'toDate', 'cursor', 'limit'] },
    ],
  },
);
